import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { getUser } from '../services/auth';
import { parseDataJogo } from '../utils/dataJogo';
import './Jogos.css';

function BloqueadoBanner({ navigate }) {
  return (
    <div className="bloqueado-msg">
      <div className="bloqueado-icon">🔒</div>
      <h2>Acesso suspenso</h2>
      <p>Sua participação está temporariamente suspensa devido à pendência de pagamento. Envie um comprovante PIX para voltar a participar dos palpites.</p>
      <button className="btn btn-primary" onClick={() => navigate('/comprovante')}>Enviar Comprovante PIX</button>
    </div>
  );
}

function formatData(d) {
  return parseDataJogo(d).toLocaleString('pt-BR', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
}

export default function Jogos() {
  const [campeonatos, setCampeonatos] = useState([]);
  const [campSel, setCampSel] = useState('');
  const [jogos, setJogos] = useState([]);
  const [meusPalpites, setMeusPalpites] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const user = getUser();

  useEffect(() => {
    if (user?.bloqueado) return;
    api.get('/campeonatos').then(setCampeonatos).catch(() => {});
    api.get('/palpites/meus').then(setMeusPalpites).catch(() => {});
  }, []);

  useEffect(() => {
    if (user?.bloqueado || !campSel) { setJogos([]); return; }
    setLoading(true);
    api.get(`/jogos?campeonato_id=${campSel}`).then(setJogos).catch(() => {}).finally(() => setLoading(false));
  }, [campSel]);

  if (user?.bloqueado) return <BloqueadoBanner navigate={navigate} />;

  return (
    <div>
      <h1 className="page-title">Jogos</h1>
      <div className="form-group">
        <label>Campeonato</label>
        <select value={campSel} onChange={e => setCampSel(e.target.value)}>
          <option value="">Selecione um campeonato</option>
          {campeonatos.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
      </div>
      {loading && <div className="loading"><div className="spinner" /></div>}
      {jogos.map(j => {
        const palpiteExistente = meusPalpites.find(p => Number(p.jogo_id) === Number(j.id));
        const finalizado = !!j.finalizado;

        return (
          <div key={j.id} className={`jogo-item${finalizado ? ' finalizado' : ''}`}>
            <div className="jogo-meta">
              <span>{formatData(j.data_jogo)}</span>
              <span>{j.rodada_nome}</span>
            </div>
            <div className="jogo-confronto">
              <span className="tc">{j.time_casa_nome}</span>
              {finalizado
                ? <span className="placar-fin">{j.gols_casa} x {j.gols_fora}</span>
                : <span className="vs-txt">vs</span>}
              <span className="tf">{j.time_fora_nome}</span>
            </div>
            {!finalizado && !palpiteExistente && (
              <button
                className="btn btn-primary btn-palpitar"
                onClick={() => navigate('/palpites', { state: { jogo: j } })}
              >
                🎯 Palpitar
              </button>
            )}
            {!finalizado && palpiteExistente && (
              <button
                className="btn btn-editar-palpite btn-palpitar"
                onClick={() => navigate('/palpites', { state: { jogo: j, palpiteExistente } })}
              >
                ✏️ Editar Palpite
                <span className="palpite-atual">{palpiteExistente.palpite_casa}x{palpiteExistente.palpite_fora}</span>
              </button>
            )}
            {finalizado && <span className="badge badge-success">Finalizado</span>}
          </div>
        );
      })}
      {campSel && !loading && jogos.length === 0 && <p className="empty-msg">Nenhum jogo encontrado.</p>}
    </div>
  );
}
